import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  flightSearchForm: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 4px',
    [Theme.breakpoints.up('sm')]: {
      padding: '24px 14px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '25px',
      '& .MuiInputAdornment-positionStart': {
        marginLeft: '16px',
      },
    },
    '& > .MuiGrid-container': {
      alignItems: 'flex-start',
    },
  },
  flightSearchFormDesktop: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '33px calc(70px - 15px) calc(30px - 20px) calc(70px - 15px)',
  },

  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  paper: {
    outline: 'none',
    maxWidth: '560px',
    width: '90%',
  },

  contentModal: {
    padding: '40px 32px 32px',
    position: 'relative',

    '& h3': {
      fontSize: Theme.typography.size[5],
      fontFamily: Theme.typography.base.regular,
      margin: 0,
      paddingBottom: 16,
      color: Theme.palette.text.brand,

      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[6],
      },
    },

    '& p': {
      fontSize: Theme.typography.size[2],
      fontFamily: Theme.typography.base.regular,
      margin: 0,
      color: Theme.palette.gray[750],
      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[3],
      },
    },
  },

  actionsModal: {
    padding: '24px 32px 32px',
    justifyContent: 'flex-end',
    backgroundColor: Theme.palette.gray[150],
  },
  closeModalIcon: {
    position: 'absolute',
    right: 16,
    top: 16,
    width: 24,
    height: 24,
    fill: Theme.palette.primary.light,
  },
}));

export default useStyles;
